import http, { apiErrorMessage } from '../../http';

export const getSucursales = () =>{
    return(dispatch, getState) => {
        http.get('catalogos/sucursales')
        .then(function (response){
            // Envelope v1: {data:[{value,label},...]} (options del react-select)
            dispatch({
                type: "CATALOGO_SUCURSAL_LIST_SUCCESS", payload: {
                    data: response.data.data,
                }
            });
        })
        .catch(function (error) {
            dispatch({ type: 'CATALOGO_SUCURSAL_ERROR', payload: { error: apiErrorMessage(error) } });
        })
        .finally(function () {
            //dispatch({ type: 'HIDE_LOADING' });
        });
    }
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({type: "CATALOGO_SUCURSAL_CLOSE_MESSAGES"});
    }
}
